var hiddenKeys;
var hasRequiredHiddenKeys;

function requireHiddenKeys () {
	if (hasRequiredHiddenKeys) return hiddenKeys;
	hasRequiredHiddenKeys = 1;
	hiddenKeys = {};
	return hiddenKeys;
}

export { requireHiddenKeys as __require };
//# sourceMappingURL=node_modules-core-js-internals-hidden-keys.js.map
